import { useMemo } from 'react';
import { twJoin } from 'tailwind-merge';

import type { FC, PropsWithChildren} from 'react';

export type ProgressBarProps = PropsWithChildren<{
  progress?: number;
}>;

export const ProgressBar: FC<ProgressBarProps> = props => {
  const { progress: progressArg, children } = props;

  const progress = useMemo(() => {
    if (typeof progressArg === 'undefined') {
      return 0;
    }

    if (progressArg < 0) {
      return 0;
    }

    if (progressArg > 1) {
      return 1;
    }

    return progressArg;
  }, [progressArg]);

  const progressElement = (
    <div
      className={twJoin(
        'h-1 rounded-sm bg-opacity-black-10 [&>*]:h-[inherit] [&>*]:bg-surface-primary-100',
        'rounded-sm [&>*]:rounded-[inherit]',
      )}
    >
      <div
        style={{ width: `${progress * 100}%` }}
        className="transition-[width]"
      />
    </div>
  );

  if (!children) {
    return progressElement;
  }

  return (
    <div
      className={twJoin(
        'space-y-1 text-center text-marine-high-emphasis',
        '[&_strong]:font-semibold',
      )}
    >
      {progressElement}
      {children}
    </div>
  );
};
